import { LobbyImage } from '@colonist/types';
import { HistoryTable, ItemsTab, OverviewTab, ProfilePageTabId } from '@colonist/clientforge';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { createImgIn, setElementInnerHTML } from '../ui_utils/DomUtils.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
import { toOverviewBadges, toOverviewStats } from './overviewUtils.ts';
import { UIProfileRankedController } from './UIProfileRankedController.ts';
import { UIProfileRankedSeasonDropdownController } from './UIProfileRankedSeasonDropdownController.ts';
import { UIProfileLinkController } from './UIProfileLinkController.ts';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { UIProfileFriendsController } from './UIProfileFriendsController.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { mountUIReactComponent } from '../ui_platform/mountUIReactComponent.tsx';
import { toOwnedStoreItems } from './itemUtils.ts';
import { uiManagerEvents } from '../EntryShared.ts';
import { navigateToReplay, toHistoryGameViews } from './historyUtils.ts';
import { getProfilePopupElementId, UIViewProfilePopup } from './UIViewProfilePopup.ts';
export class UIPopupProfileController {
    init(selectedTab) {
        this.profileLinkController.showSection(selectedTab);
        void this.setStickyPlayerInfo();
        void this.makeApiCall();
    }
    onTabSelected(tabId) {
        this.profileLinkController.showSection(tabId);
        void this.makeApiCall();
    }
    async setStickyPlayerInfo() {
        UIPopupProfileController.setUserIcon(this.stickyPlayerInfo.iconImageId);
        UIPopupProfileController.setMembershipIcon(this.stickyPlayerInfo.currentMembershipType);
        UIPopupProfileController.setStickyUsername(this.stickyPlayerInfo.username);
    }
    async makeApiCall() {
        switch(this.profileLinkController.activeTabId){
            case ProfilePageTabId.Overview:
                if (this.overviewView == undefined) {
                    this.overviewView = mountUIReactComponent('profile_popup_overview_div', OverviewTab);
                    this.overviewView.render({
                        stats: undefined,
                        badges: undefined
                    });
                }
                await this.profileLinkController.genericApiCallWrapper(ProfilePageTabId.Overview, UIAPIEndpoints.apiUserProfile.overview(this.username), (data)=>{
                    var _this_overviewView;
                    (_this_overviewView = this.overviewView) === null || _this_overviewView === void 0 ? void 0 : _this_overviewView.render({
                        stats: toOverviewStats(data),
                        badges: toOverviewBadges(data.userId)
                    });
                });
                break;
            case ProfilePageTabId.History:
                await this.profileLinkController.genericApiCallWrapper(ProfilePageTabId.History, UIAPIEndpoints.apiUserProfile.history(this.username), (data)=>{
                    this.setHistory(data);
                });
                break;
            case ProfilePageTabId.Items:
                await this.profileLinkController.genericApiCallWrapper(ProfilePageTabId.Items, UIAPIEndpoints.apiUserProfile.items(this.username), (items)=>{
                    this.setItems(items);
                });
                break;
            case ProfilePageTabId.Ranked:
                await this.profileLinkController.genericApiCallWrapper(ProfilePageTabId.Ranked, UIAPIEndpoints.apiUserProfileRankedSeasons(), (seasons)=>{
                    this.setRankedSeasons(seasons);
                });
                break;
            default:
                break;
        }
    }
    static setStickyUsername(username) {
        const usernameElement = document.getElementById('profile_popup_sticky_player_info_username');
        setElementInnerHTML(usernameElement, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: username
            }
        });
    }
    static setUserIcon(iconImage) {
        const iconContainer = document.getElementById('profile_popup_sticky_player_info_icon');
        const lobbyImage = iconImage !== null && iconImage !== void 0 ? iconImage : LobbyImage.Guest;
        createImgIn(iconContainer, lobbyImage, 'profile-icon');
    }
    static setMembershipIcon(membershipType) {
        const iconContainer = document.getElementById('profile_popup_sticky_player_info_icon');
        if (membershipType == undefined) return;
        const membershipIconLobbyImage = ColonistMembershipProduct.getMembershipProduct(membershipType).lobbyImage;
        createImgIn(iconContainer, membershipIconLobbyImage, 'profile-membership-icon', 'profile_popup_sticky_player_membership_icon');
    }
    setHistory(historyData) {
        const { gameDatas, profileUserId } = historyData;
        const games = toHistoryGameViews(gameDatas, profileUserId, {
            isPopup: true
        });
        const mountId = getProfilePopupElementId('game-history-table', true);
        if (this.historyView == undefined) this.historyView = mountUIReactComponent(mountId, HistoryTable);
        this.historyView.render({
            games: games,
            profileUsername: decodeURIComponent(this.username),
            showReplayColumn: !UIUtilsEjsVariables.shouldHideStoreOnMobile,
            onReplayClick: navigateToReplay,
            onUsernameClick: (username)=>UIViewProfilePopup.init(username)
        });
    }
    setRankedSeasons(seasons) {
        new UIProfileRankedSeasonDropdownController(seasons, this.rankedController, true);
    }
    setItems(items) {
        if (this.itemsView == undefined) this.itemsView = mountUIReactComponent('profile_popup_profile_items_div', ItemsTab);
        const isInGameOnMobile = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && uiManagerEvents.isSceneGame();
        const storeBaseHref = UIUtilsEjsVariables.isUserOnDiscord ? 'https://colonist.io/store' : '/store';
        const onItemClick = isInGameOnMobile ? undefined : (item)=>navigateToPage(`${storeBaseHref}#${item.categorySlug}`);
        this.itemsView.render({
            items: toOwnedStoreItems(items),
            onItemClick: onItemClick
        });
    }
    constructor(username, stickyPlayerInfo, selectedTab){
        this.username = username;
        this.stickyPlayerInfo = stickyPlayerInfo;
        this.profileLinkController = new UIProfileLinkController(true, username, (tabId)=>this.onTabSelected(tabId));
        this.rankedController = new UIProfileRankedController(this.username, true);
        const stickyPlayerTextContainer = document.getElementById('profile_popup_sticky_player_info_text_container');
        this.friendsController = new UIProfileFriendsController(this.username, this.profileLinkController, stickyPlayerTextContainer, true);
        this.init(selectedTab);
    }
}
